// extracted by mini-css-extract-plugin
export default {"notfound":"ui_notfound__q+7-n"};